import React, { Component } from "react";

import {
  getSalesInformations,
  reorderSalesInformations,
  deleteSalesInformation
} from "../../services/api";

import List from "../../components-utils/List";

export default class Values extends Component {
  render() {
    return (
      <List
        getItems={getSalesInformations}
        deleteItem={deleteSalesInformation}
        reorderItem={reorderSalesInformations}
        path="/sales-informations"
        elementName="liste de valeurs"
        elementGender="f"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sales-informations/SalesInformations.js